<div *ngIf="meeting?.id" class="meeting" [class.mobile]="deviceService.isMobile()">
  <div class="item">
    <ng-template #otherCases>
    <p class="title">{{'user-service-card-full.titles.registered-class' | customLocale}} {{ formatDate(meeting.begin_at) | dfnsFormat: 'dd MMMM yyyy HH:mm' }}-{{ formatDate(meeting.end_at) | dfnsFormat: "HH:mm" }}</p>
    <a class="link" [routerLink]="classroomRoute(meeting.classroom)">{{'classrooms.classroom.open-classroom' | customLocale}}</a>
    </ng-template>

    <ng-template [ngIf]="isAcceptRequired"  [ngIfElse]="otherCases">
      <p class="title">{{ 'user-service-card-full.titles.accept-required' | customLocale : {
        'date': (' ' + (formatDate(meeting.begin_at) | dfnsFormat: 'dd MMMM yyyy HH:mm') + '-' + (formatDate(meeting.end_at) | dfnsFormat: "HH:mm")),
      } }}</p>
      <p (click)="meetingCheckoutDialogOpened=true" class="link">{{'user-service-checkout-wizard.pay' | customLocale}}</p>
    </ng-template>
  </div>
</div>

<app-meeting-checkout-wizard-dialog
  *ngIf="meetingCheckoutDialogOpened"
  [meetingId]="meeting.id"
  (succeed)="onPaymentSucceed()"
  (closed)="meetingCheckoutDialogOpened=false"
></app-meeting-checkout-wizard-dialog>
